/* eslint-disable filename-rules/match */

import { useMemo } from 'react'

import { useRouter } from 'next/router'
import type { LinkHTMLAttributes } from 'react'

import { supportedRegions } from '@cash-web/support/utils-region-config'

import { fallbackLng as defaultLocale } from '../../next-i18next.config'

const frontendServiceUrl = process.env['NEXT_PUBLIC_FRONTEND_SERVICE_URL']

/**
 * Generate a canonical URL
 * @returns A URL that can be used for link rel="canonical", with region preceding the locale, as that's what's used on the public frontend
 */
const useCanonicalURL = (...pathSections: string[]): React.ReactElement<LinkHTMLAttributes<HTMLLinkElement>> => {
  const router = useRouter()

  return useMemo(() => {
    // On the public facing site, locale is after the region in the URL.
    const region = router.query['region']?.toString()?.toLowerCase() as keyof typeof supportedRegions | undefined
    const regionConfig = region ? supportedRegions[region] : undefined

    // Use region's default locale if current locale is app's default, otherwise use current locale
    const locale = router.locale === defaultLocale ? (regionConfig?.defaultLocale ?? router.locale) : router.locale

    const url = [`${frontendServiceUrl}${router.basePath}`, region, locale, ...pathSections].filter(Boolean).join('/')

    return <link rel="canonical" hrefLang={locale} href={url} />
  }, [router.basePath, router.locale, router.query, pathSections])
}

export default useCanonicalURL
